import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';

import projectsStore from 'storeState/projects';
import authStore from 'storeState/auth';

import HtmlPage from 'views/htmlPage/HtmlPage';

import ProjectsSummaryList from 'views/projectsSummaryList/ProjectsSummaryList';

import URLService from 'service/URLService';

import './dashboard.scss';

class Dashboard extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.projectsListRequest({tenant_id: this.props.currentTenantId});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if(prevProps.currentTenantId != this.props.currentTenantId) {
        this.props.actions.projectsListRequest({tenant_id: this.props.currentTenantId});
      }
    }

    handleProjectSelect = (id) => {
        URLService.gotoPush('/translations/'+id);
    }

    render() {
        return (
            <HtmlPage className="screen-dashboard" >
                <div className="content-dashboard">
                    <ProjectsSummaryList
                        onProjectSelect={this.handleProjectSelect}
                    />
                </div>
            </HtmlPage>
        );
    }
}

export default connect((state, props) => {
    return {
        projects: projectsStore.selectors.projectsList(state),
        currentTenantId: authStore.selectors.currentTenantId(state)
    }
},(dispatch, props) => {
    return {
        actions: bindActionCreators(Object.assign({}, projectsStore.actions), dispatch)
    }
})(Dashboard)


// WEBPACK FOOTER //
// ./src/components/screens/dashboard/Dashboard.js